import React, { useState } from "react";
import { useDispatch } from "react-redux";
import UserApi from "../../api/UserApi";
import IconInfo from "../../Icons/NotificationMessage/Info";
import { ENotificationType } from "../../Model/ENotificationType";
import { User } from "../../Model/User";
import { sendNotification } from "../../redux/actions/NotificationAction";
import { getNotifications } from "../../redux/reducers/NotificationReducer";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import UserUtil from "../../Utility/UserUtil";
import MtiButton from "../Buttons/MtiButton";
import CommandPanel from "../CommandPanel/CommandPanel";
import TextBox from "../Common/TextBox";
import "./EditProfilePanel.css";

type Props = {
  user: User;
  style?: React.CSSProperties;
  backBtn: () => void;
  onUserUpdated: () => void;
};

export default function EditProfilePanel({
  user,
  style,
  backBtn,
  onUserUpdated,
}: Props) {
  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.userEmail);
  const notifications = useTypedSelector((state) => getNotifications(state));
  const dispatch = useDispatch();

  const onClickEditProfile = () => {
    let newUser = { ...user };
    if (name) {
      newUser.name = name;
    }
    if (email) {
      newUser.userEmail = email;
    }
    UserApi.updateUser(newUser).then((result) => {
      if (notifications.length === 0) {
        dispatch(
          sendNotification(ENotificationType.Success, "Edit Profile Success")
        );
        onUserUpdated();
        backBtn();
      }
    });
  };

  const allEmpty = email === "" && name === "";
  const allDefault = email === user.userEmail && name === user.userName;
  const isEmailValidFormat = UserUtil.IsValidEmailFormat(email) || email == "";

  return (
    <CommandPanel>
      <CommandPanel.UsersInfoHeader users={[user]} />
      <CommandPanel.BackArrowHeader
        title="Edit Profile"
        onBackArrowClick={backBtn}
      />
      <CommandPanel.VerticalContent>
        <div className="profile-container">
          <div className="profile-field">
            <label className="profile-label">Name</label>
            <TextBox
              name="name"
              value={name}
              onChange={(value) => setName(value as string)}
              variant="text"
              className="profile-input"
            />
          </div>

          <div className="profile-field">
            <label className="profile-label">Email</label>
            <TextBox
              name="email"
              value={email}
              onChange={(value) => setEmail(value as string)}
              variant="text"
              className={
                isEmailValidFormat
                  ? "profile-input"
                  : "profile-input red-border"
              }
            />
            {!isEmailValidFormat && (
              <div className="not-email">
                <div style={{ display: "flex" }}>
                  <IconInfo fill="#C92932" width="10" height="10" />
                </div>
                <p>the email is not valid!</p>
              </div>
            )}
          </div>

          <div className="profile-buttons">
            <MtiButton
              size="large"
              onClick={backBtn}
              variant="secondary"
              style={{ marginRight: 10 }}
            >
              Cancel
            </MtiButton>
            <MtiButton
              size="large"
              onClick={onClickEditProfile}
              disabled={
                !UserUtil.IsValidEmailFormat(email) || allEmpty || allDefault
              }
            >
              Yes
            </MtiButton>
          </div>
        </div>
      </CommandPanel.VerticalContent>
    </CommandPanel>
  );
}
